import {Model} from "@vuex-orm/core";

export default class CompositionAllowance extends Model {

    static entity = 'compositionAllowances';

    static primaryKey = ['product_detail_composition_id', 'product_allowance_id'];

    static fields () {
        return {
            product_detail_composition_id: this.attr(null),
            product_allowance_id: this.attr(null),
        }
    }
}
